export const EmptyState = ({ icon: Icon, title, description, action, testid = "empty-state" }) => (
  <div
    data-testid={testid}
    className="flex flex-col items-center text-center gap-4 rounded-3xl border border-dashed border-black/10 bg-[#F9F9F9] px-8 py-16"
  >
    {Icon && (
      <div className="w-14 h-14 rounded-full bg-white border border-black/5 flex items-center justify-center shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <Icon className="w-6 h-6 text-[#1D4D3B]" aria-hidden="true" />
      </div>
    )}
    <h3 className="text-xl sm:text-2xl font-medium text-[#0A0A0A] tracking-tight">{title}</h3>
    {description && (
      <p className="text-sm text-[#737373] leading-relaxed max-w-md">{description}</p>
    )}
    {action && <div className="mt-2">{action}</div>}
  </div>
);
